export default "__VITE_ASSET__Beluz8W0__"